export const LOAD_FIELDS = 'customFields/LOAD_FIELDS';
export const ADD_FIELD = 'customFields/ADD_FIELDS';
export const UPDATE_FIELD = 'customFields/UPDATE_FIELDS';
export const DELETE_FIELD = 'customFields/DELETE_FIELD';
